import { Injectable, OnDestroy, OnInit } from '@angular/core';
import { Http, Response } from '@angular/http';

import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ReplaySubject } from 'rxjs/ReplaySubject'
import { AuthHttp, AuthHttpError, JwtHelper }   from 'angular2-jwt';
import { Location } from '@angular/common';

@Injectable()
export class ApiService {
  private baseUrl: string = "/admin/api";

  constructor(
    private http: Http,
    private location: Location
  ) {}

  public setBaseUrl(baseUrl: string): void {
    this.baseUrl = baseUrl;
  }

  public get(url: string): Observable<Response> {
    let fullUrl = this.getFullUrl(url);
    let httpPromise = this.http.get(fullUrl).catch(this.handleError)
    return httpPromise;
  }

  public put(url: string, body: any): Observable<Response> {
    let fullUrl = this.getFullUrl(url);
    let httpPromise = this.http.put(fullUrl, body).catch(this.handleError)
    return httpPromise;
  }

  public patch(url: string, body: any): Observable<Response> {
    let fullUrl = this.getFullUrl(url);
    let httpPromise = this.http.patch(fullUrl, body).catch(this.handleError)
    return httpPromise;
  }

  public post(url: string, body: any): Observable<Response> {
    let fullUrl = this.getFullUrl(url);
    let httpPromise = this.http.post(fullUrl, body).catch(this.handleError)
    return httpPromise;
  }

  public delete(url: string): Observable<Response> {
    let fullUrl = this.getFullUrl(url);
    let httpPromise = this.http.delete(fullUrl).catch(this.handleError)
    return httpPromise;
  }

  public getBaseUrl(): string {
    return this.baseUrl;
  }

  private getFullUrl(url: string): string {
    let editionId = localStorage.getItem('edition_id');
    let fullUrl = this.baseUrl + url;
    if(editionId) {
      let sep = '?';
      if(fullUrl.indexOf('?') > -1) {
        sep = '&';
      }
      return `${fullUrl}${sep}edition_id=${editionId}`;
    }
    else {
      return fullUrl;
    }
  }

  private handleError(err: any) {
    // 401 is for a token which exists but is expired, AuthHttpError is for no token
    if (err.status === 401 || err instanceof AuthHttpError) {
      let token = localStorage.getItem('id_token');
      let host = location.host;
      let protocol = location.protocol;
      let relativeLocation = encodeURIComponent(window.location.pathname + window.location.search + window.location.hash);
      relativeLocation = relativeLocation.replace('/admin/portal', '');
      let authUrl = `${protocol}//${host}/auth/admin_portal?dest=${relativeLocation}`;
      if (token) {
        let helper = new JwtHelper();
        let jwt = helper.decodeToken(token);
        if (jwt.refresh) {
          authUrl = jwt.refresh + '?dest=' + relativeLocation;
        }
      }
      window.location.assign(authUrl);
    }
    return Observable.throw(err || 'HTTP error');
  }
}



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/root-services/api.service.ts